/**
* @Author: zachalam
* @Date:   2017-01-19T17:04:50-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-19T17:05:30-08:00
*/

import React, { Component } from 'react';
import Billing from '../components/pages/Billing/Billing';


class BillingContainer extends Component {

  render() {
    return (
      <Billing />
    );
  }
}

export default BillingContainer;


// WEBPACK FOOTER //
// ./src/containers/BillingContainer.jsx